// =============================================================================
// Input / Select / SearchBar components
// =============================================================================

import { forwardRef, type InputHTMLAttributes, type SelectHTMLAttributes } from "react";
import clsx from "clsx";

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={clsx("input-base", className)} {...props} />
  )
);
Input.displayName = "Input";

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, options, ...props }, ref) => (
    <select ref={ref} className={clsx("select-base", className)} {...props}>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  )
);
Select.displayName = "Select";

export const SearchBar = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, placeholder = "Search...", ...props }, ref) => (
    <input
      ref={ref}
      type="search"
      className={clsx("search-bar", className)}
      placeholder={placeholder}
      {...props}
    />
  )
);
SearchBar.displayName = "SearchBar";
